import React, { useContext, useRef, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { CrudForm, useEntityManager, AuthContext, Snackbar } from 'elentari'
import tarefaRepository from './tarefaRepository'
import yupValidation from '../../lib/yupValidation'
import arrayMutators from 'final-form-arrays'
import LogAlteracoesCards from './Log/LogAlteracoesCard'
import { Card, makeStyles, Step, StepButton, Stepper } from '@material-ui/core'
import ChatCard from '../Chats/ChatCard'
import MiniStepper from '../../components/MiniStepper'
import { useAbility } from '../Usuarios'
import ComplexDialog from '../../components/ComplexDialog'
import { TarefaStatusEnum, TarefaStatusColors } from './TarefaStatus'
import { AnexosCard } from './Anexos'
import MonitoramentoForm from './Form/MonitoramentoForm'
import { tarefaSchema } from './TarefaEmbarcador/tarefaSchema'
import { concatObservacao } from '../../utils/ConcatObservacao'
import { CustomDatePicker, CustomTextField } from '../../components/CustomDisabledFields'
import { Field } from 'react-final-form'
import GerenciadoraField from './Fields/GerenciadoraField'
import * as R from 'ramda'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2)
  },
  mainStepper: {
    overflowX: 'scroll',
    marginBottom: theme.spacing(2)
  },
  pendenteMotorista: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: TarefaStatusColors.PENDENTEMOTORISTA,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.PENDENTEMOTORISTA_DARK
    }
  },
  pendenteFilial: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: TarefaStatusColors.PENDENTEFILIAL,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.PENDENTEFILIAL_DARK
    }
  },
  cancelada: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: TarefaStatusColors.CANCELADA,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.CANCELADA_DARK
    }
  },
  finalizada: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: TarefaStatusColors.FINALIZADA,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.FINALIZADA_DARK
    }
  },
  liberadoViagem: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: TarefaStatusColors.LIBERADOVIAGEM,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.LIBERADOVIAGEM_DARK
    }
  },
  liberadoSemMonitoramento: {
    fontSize: '0.695em',
    height: '100%',
    backgroundColor: TarefaStatusColors.LIBERADOSEMMONITORAMENTO,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.LIBERADOSEMMONITORAMENTO_DARK
    }
  },
  reanalise: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: TarefaStatusColors.REANALISE,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.REANALISE_DARK
    }
  },
  habilitarEdicao: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%'
  }
}))

export const validateTarefa = yupValidation(tarefaSchema)

function getSteps() {
  return ['Informações gerais', 'Anexos', 'Alterações / Comentários']
}

const TarefaForm = props => {
  const classes = useStyles()
  const [ability] = useAbility()
  const { user } = useContext(AuthContext)
  const elementRef = useRef()
  const steps = getSteps()
  const [activeStep, setActiveStep] = useState(0)
  const [mensagem, setMensagem] = useState('')
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    callback: null,
    id: 0,
    mensagem: '',
    isPendente: false,
    isCancelar: false,
    isLiberadoViagem: false,
    isLiberadoSemMonitoramento: false
  })

  const entityManager = useEntityManager({
    repository: tarefaRepository,
    initialData: {
      status: true
    }
  })

  const isNew = !!entityManager.isNew

  const cannotUpdate =
    ability.cannot('update', 'tarefa') ||
    !!entityManager.item.dataTermino ||
    user.realm === 'gestor'

  const unmask = value => value.replace(/\W/g, '')

  const handleSubmit = async data => {
    const submitData = {
      cpfMotorista: unmask(data.cpfMotorista),
      placaCavalo: unmask(data.placaCavalo),
      observacao: concatObservacao(
        data.observacao,
        data.novaObservacao,
        user.name
      ),
      ...data
    }

    const files = {
      cnh: data.cnh,
      crlv: data.crlv,
      crlvPlaca1: data.crlvPlaca1,
      crlvPlaca2: data.crlvPlaca2,
      crlvPlaca3: data.crlvPlaca3,
      isca: data.isca ? data.isca : undefined
    }

    delete submitData.cnh
    delete submitData.crlv
    delete submitData.crlvPlaca1
    delete submitData.crlvPlaca2
    delete submitData.crlvPlaca3
    delete submitData.isca
    delete submitData.novaObservacao

    return entityManager.onSubmit(submitData, files)
  }

  const scrollTop = () => {
    const stepElement = document.getElementById('content')
    setTimeout(() => {
      stepElement && stepElement.scrollIntoView()
    }, 200)
  }

  const handleStep = step => async () => {
    setActiveStep(step)
    scrollTop()
  }

  const handleActionsClick = async (id, callback, operacao) => {
    setConfirmationDialog({
      open: true,
      callback,
      id,
      mensagem: `O novo status dessa Solicitação de Monitoramento será: ${operacao}`,
      isPendenteFilial: operacao === 'Aguardando Liberação',
      isCancelar: operacao === 'Cancelada',
      isLiberadoViagem: operacao === 'Liberado',
      isLiberadoSemMonitoramento: operacao === 'Liberado sem Monitoramento'
    })
  }

  const closeDialog = () => {
    setConfirmationDialog({
      mensagem: '',
      isPendente: false,
      open: false,
      callback: null,
      id: 0
    })
  }

  const handleConfirmationDialog = async data => {
    const { id, callback } = confirmationDialog
    if (callback) {
      const response = await callback(id, data)
      if (response.ok) {
        setMensagem(`Status alterado com sucesso!`)
        if (
          response.data?.sucessoKmm !== undefined &&
          !response.data.sucessoKmm
        ) {
          setMensagem(
            `Falha ao sincronizar com KMM, entre em contato com a Central de Cadastros!`
          )
        }
      } else {
        setMensagem(
          R.pathOr(
            'Ops, algo deu errado!',
            ['data', 'error', 'message'],
            response
          )
        )
      }
      entityManager.getItem()
    }
  }

  const customActionsFactory = item => {
    if (item.dataTermino) {
      if (user.realm === 'admin' || user.realm === 'analista_op_2') {
        return [
          {
            label: 'Habilitar edição',
            props: {
              color: 'secondary',
              className: classes.habilitarEdicao,
              variant: 'contained'
            },
            onClick: () =>
              handleActionsClick(
                item.id,
                tarefaRepository.removerDataTermino,
                'Aberto e a Data de Término será removida.'
              )
          }
        ]
      }
      return []
    }
    const pendenteFilial = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Aguardando Liberação',
      props: {
        color: 'inherit',
        className: classes.pendenteFilial,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(
          item.id,
          tarefaRepository.pendenteFilial,
          'Aguardando Liberação'
        )
      }
    }

    const finalizada = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Finalizada',
      props: {
        color: 'inherit',
        className: classes.finalizada,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(item.id, tarefaRepository.finalizada, 'Finalizada')
      }
    }

    const liberadoViagem = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Liberado',
      props: {
        color: 'inherit',
        className: classes.liberadoViagem,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(item.id, tarefaRepository.liberadoViagem, 'Liberado')
      }
    }

    const liberadoSemMonitoramento = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Liberado sem Monitoramento',
      props: {
        color: 'inherit',
        className: classes.liberadoSemMonitoramento,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(
          item.id,
          tarefaRepository.liberadoSemMonitoramento,
          'Liberado sem Monitoramento'
        )
      }
    }

    const reanalise = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Reánalise',
      props: {
        color: 'inherit',
        className: classes.reanalise,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(item.id, tarefaRepository.reanalise, 'Reanalise')
      }
    }

    const pendenciaMotorista = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Pendente',
      props: {
        color: 'inherit',
        className: classes.pendenteMotorista,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(
          item.id,
          tarefaRepository.pendenteMotorista,
          'Pendente'
        )
      }
    }

    const cancelada = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Cancelar',
      props: {
        color: 'inherit',
        className: classes.cancelada,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(item.id, tarefaRepository.cancelada, 'Cancelada')
      }
    }

    const actions = []
    switch (item.status) {
      case TarefaStatusEnum.ANALISE:
      case TarefaStatusEnum.REANALISE:
        actions.push(cancelada)
        actions.push(pendenciaMotorista)
        actions.push(pendenteFilial)
        actions.push(liberadoViagem)
        actions.push(liberadoSemMonitoramento)
        break
      case TarefaStatusEnum.LIBERADOVIAGEM:
        actions.push(cancelada)
        actions.push(finalizada)
        break
      case TarefaStatusEnum.PENDENTEFILIAL:
        actions.push(cancelada)
        if (user.realm !== 'embarcador') actions.push(reanalise)
        break
      case TarefaStatusEnum.PENDENTEMOTORISTA:
        actions.push(cancelada)
        actions.push(reanalise)
        break
      default:
        break
    }
    return actions
  }

  const customActions = customActionsFactory(entityManager.item)

  const renderContent = ({ values, form, showError, ...props }) => {
    return (
      <MonitoramentoForm
        {...props}
        values={values}
        form={form}
        showError={showError}
        isNew={isNew}
      />
    )
  }

  return (
    <>
      <MiniStepper
        elementRef={elementRef}
        steps={steps}
        activeStep={activeStep}
        handleStep={handleStep}
      />
      <Card className={classes.mainStepper}>
        <Stepper activeStep={activeStep} nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton onClick={handleStep(index)}>{label}</StepButton>
            </Step>
          ))}
        </Stepper>
      </Card>

      {activeStep === 0 && (
        <CrudForm
          {...props}
          {...entityManager}
          onSubmit={handleSubmit}
          withPaper
          validate={validateTarefa}
          formProps={{ mutators: { ...arrayMutators } }}
          initialValues={entityManager.item}
          customActions={customActions}
          disableSubmit={cannotUpdate}
        >
          {renderContent}
        </CrudForm>
      )}
      {activeStep === 1 && (
        <Card className={classes.card}>
          <AnexosCard match={props.match} cannotUpdate={cannotUpdate} />
        </Card>
      )}
      {activeStep === 2 && (
        <Card className={classes.card}>
          <Grid container spacing={6}>
            <Grid item xs={12} lg={6}>
              <LogAlteracoesCards {...props} />
            </Grid>
            <Grid item xs={12} lg={6}>
              <ChatCard tarefa {...props} cannotUpdate={cannotUpdate} />
            </Grid>
          </Grid>
        </Card>
      )}
      <ComplexDialog
        open={!!confirmationDialog.open}
        buttonLabel="Não"
        handleClose={closeDialog}
        primaryAction={handleConfirmationDialog}
        title="Deseja confirmar essa operação?"
        message={confirmationDialog.mensagem}
        primaryActionButtonLabel="Confirmar"
      >
        {confirmationDialog.isLiberadoViagem && (
          <>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12}>
                <GerenciadoraField />
              </Grid>
              <Grid item xs={12}>
                <Field
                  fullWidth
                  name="identificadorGerenciadora"
                  label="Código Identificador"
                  component={CustomTextField}
                />
              </Grid>
            </Grid>
          </>
        )}
        {confirmationDialog.isCancelar && (
          <>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12}>
                <Field
                  fullWidth
                  name="motivoCancelamento"
                  label="Motivo do Cancelamento"
                  component={CustomTextField}
                />
              </Grid>
            </Grid>
          </>
        )}
        {confirmationDialog.isLiberadoSemMonitoramento && (
          <>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12}>
                <Field
                  fullWidth
                  name="motivoLiberacao"
                  label="Motivo da Liberação"
                  component={CustomTextField}
                />
              </Grid>
            </Grid>
          </>
        )}
      </ComplexDialog>
      <Snackbar
        message={mensagem}
        autoHideDuration={6000}
        onClose={() => setMensagem('')}
      />
    </>
  )
}

export default TarefaForm
